import { type ComponentType, createContext, useContext } from "react";

import { type RenderInsert } from "./BaseWorkoutItemsList";

export const workoutItemsInsertContext = createContext<
  ComponentType<RenderInsert>
>(null!);

export function useWorkoutItemsInsert() {
  return useContext(workoutItemsInsertContext);
}
